// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2H8hE","type":"styles_type__uxnwR","choices":"styles_choices__28OsD"};